// Ritratto "cutout" (sfondo rimosso) integrato nel layout:
// nessuna cornice, solo ombra morbida e un accento astratto minimo.
export default function CutoutImage({
  src,
  alt,
  width,
  height,
  testId,
  priority = false,
  className = "",
}) {
  return (
    <div className={`relative ${className}`}>
      <div
        aria-hidden="true"
        className="absolute -right-12 -top-12 h-56 w-56 rounded-full bg-mist sm:h-80 sm:w-80"
      />
      <div
        aria-hidden="true"
        className="absolute -left-10 bottom-8 h-24 w-24 rounded-full border border-leaf/40"
      />
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={priority ? undefined : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        data-testid={testId}
        className="relative w-full [filter:drop-shadow(0_28px_36px_rgba(16,22,20,0.16))]"
      />
    </div>
  );
}
